<template>
  <div class="main">
    <layout />
    <TopbgVue :title="title" />
    <div class="list">
      <div class="item-title">{{ title }}</div>
      <div class="ul">
        <div class="li" v-for="(item, index) in listData" :key="index">
          <div @click="toDetail(item)" class="li-title">{{ item.title }}</div>
          <div class="li-text">{{ item.time }}</div>
          <div class="li-text">
            {{ item.text }}
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import TopbgVue from "./Topbg.vue";
import Footer from './footer.vue';
import Layout from './Layout.vue';
export default {
  data() {
    return {
      title: "二手车",
      listData:[{
        title:'21年艾禾旋耕机',
        time:'24-01-01',
        text:'工作二百小时左右，原装刀片，原装履带，三大件没有任​‌‌何问题，100马力，二米三旋，需要的朋友私聊联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌'
      },{
        title:'大众 帕萨特 2011款 1.8TSI 双离合 御尊版',
        time:'24-01-01',
        text:'13年2月帕萨特，1.8T尊荣版，电动座椅，座椅加热，多功能方向盘，定速巡航，天窗，导航，倒车影像，倒车雷达，黑车黑内，本地一手车，12万公里，全车原漆。联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌​‌‌'
      },{
        title:'丰田 雅力士 2016款 YARiS L 致炫 1.5GS',
        time:'24-01-02',
        text:'车子无事故。家里代步的车子，整体表现还可以，省油好开，练手车联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌​‌‌​‌‌'
      },{
        title:'奥迪A6 2010款 A6L 3.0TFSI 手自一体 Qu',
        time:'24-01-03',
        text:'10年精品奥迪A6L3.0T，Quattro四驱，太阳能天窗，车辆无人状态下自动调节驾驶室内温度，空气悬挂，机器变速超级好，内置无线电电话，后排遥控操作前后通风座椅加热，BOSE音响，原始发票都在，开票价格69.8.全车原版，内饰整洁如新，发变完美，价格实在，支持置换和贷款联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌​‌‌​‌‌​‌‌'
      },{
        title:'货箱8.4米随车吊 前四后八18吨随车吊',
        time:'24-01-04',
        text:'货箱8.4米随车吊前四后八18吨随车吊大小任意选随车吊是属于工程车类型，目前随着农村城乡建设的不断发展，我公司特生产出一系列适合农村城乡建设的随车起重运输车1.【质量保障】：国家发改委定点生产的专业厂家!2.【厂家直销】：产品由厂家直接销售，拒绝中间环节，为您节省开支!3.【代办分期】：为客户代办全国分期付款业务，分期选择灵活，解决用户后顾之忧!4.【郑重承诺】：凡本公司销售产品，底盘/吊机部分由全国服务站联保,改装部分由我公司“三包”服务一年。东风新款天龙前四后八随车吊康明斯360马力，东风14档变速箱，前后桥：5..5/10吨，三层直通车架，11.00R20钢丝胎。联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌‌'
      }]
    };
  },
  components: {
    TopbgVue,
    Layout,
    Footer
  },
  mounted() {
  },
  methods: {
    toDetail(item) {
      this.$router.push({
        path:'/detail',
        query: {
          title: item.title,
          text: item.time,
          detail: item.text,
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
.list {
  max-width: 1320px;
  margin: 80px auto 0;
  .item-title {
    margin-bottom: 30px;
    font-size: 24px;
    font-weight: bold;
    color: #0099cc;
  }
  .ul {
    padding: 0 30px 50px 200px;
    background: #f0f8ff;
    .li {
      padding-top: 50px;
      .li-title {
        cursor: pointer;
        font-size: 16px;
        font-weight: bold;
        color: #000000;
      }
      .li-text {
        padding-top: 10px;
        font-size: 16px;
        color: #717275;
      }
      .li-text:nth-child(2) {
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2; /*省略几行写几*/
        -webkit-box-orient: vertical;
      }
    }
  }


}
</style>